import React from "react";
import ViewMedicalData from "./ViewMedicalData";

const ViewPmeScheduleList = () => {
  return <ViewMedicalData isPmeSchedule />;
};

export default ViewPmeScheduleList;
